import { Button } from 'components/Button';
import { IconBook, IconFlagBanner, IconChartBar, IconHammerDuotone } from 'components/Icons';
import { Link } from 'components/Link';
import { flex } from 'styles/utils';
import { HomeCard } from '../components/HomeCard';
import { divider, docsCard, docsCardDescription, docsCardLinksWrapper, docsCardTitle, docsCardTitleWrapper } from './Docs.styles';
import { homePageFooterLink } from '../HomePageLayout.styles';
import { HorizontalLayout } from '../layout/HorizontalLayout';
import { HomeCardId, mapIdToTitle } from '../constants';

const documentationLinks = [
  {
    title: 'Get Started',
    description: 'Set up your environment and explore key features.',
    icon: IconFlagBanner,
    links: [
      {
        text: 'Quick Start Guide',
        url: 'https://docs.clarifai.com/clarifai-basics/quick-start/your-first-predictions/',
      },
      {
        text: 'Applications',
        url: 'https://docs.clarifai.com/clarifai-basics/applications/',
      },
      {
        text: 'Authentication',
        url: 'https://docs.clarifai.com/clarifai-basics/authentication/',
      },
      {
        text: 'Set up SDK',
        url: 'https://docs.clarifai.com/sdk/python-installation',
      },
    ],
  },
  {
    title: 'Build & Train AI',
    description: 'Train own models and create custom solutions.',
    icon: IconChartBar,
    links: [
      {
        text: 'Upload Inputs for labeling',
        url: 'https://docs.clarifai.com/portal-guide/inputs-manager/',
      },
      {
        text: 'Train your first Model',
        url: 'https://docs.clarifai.com/portal-guide/model/',
      },
      {
        text: 'Chain Models in Workflows',
        url: 'https://docs.clarifai.com/portal-guide/workflows/',
      },
      {
        text: 'Monitor usage and spend',
        url: 'https://docs.clarifai.com/portal-guide/control-center/',
      },
    ],
  },
  {
    title: 'Deploy & Scale AI',
    description: 'Optimize and manage AI models in production.',
    icon: IconHammerDuotone,
    links: [
      {
        text: 'Explore Community models',
        url: 'https://docs.clarifai.com/portal-guide/ppredict/',
      },
      {
        text: 'Deploy to dedicated cluster',
        url: 'https://docs.clarifai.com/portal-guide/compute-orchestration/',
      },
      {
        text: 'Manage your Compute',
        url: 'https://docs.clarifai.com/portal-guide/compute-orchestration/manage',
      },
      {
        text: 'Leverage team work within Organizations',
        url: 'https://docs.clarifai.com/portal-guide/clarifai-organizations/',
      },
    ],
  },
];

export function Docs() {
  return (
    <HomeCard
      title={mapIdToTitle[HomeCardId.Docs]}
      description="Explore essential guides to get the most out of AI development."
      action={
        <Link href="https://docs.clarifai.com/" rel="noreferrer" target="_blank">
          <Button size="md" variant="tertiary" LeftIcon={IconBook}>
            See All Docs
          </Button>
        </Link>
      }
    >
      <HorizontalLayout>
        {documentationLinks.map(({ title, description, links, icon: Icon }) => (
          <div key={`docs-card-${title}`} className={docsCard}>
            <div className={flex.flex.one}>
              <div className={docsCardTitleWrapper}>
                <Icon size={24} />
                <h3 className={docsCardTitle}>{title}</h3>
              </div>
              <p className={docsCardDescription}>{description}</p>
            </div>
            <div className={divider} />
            <ul className={docsCardLinksWrapper}>
              {links.map(({ text, url }) => (
                <li key={`docs-card-${title}-link-${text}`}>
                  <Link rel="noreferrer" target="_blank" href={url} className={homePageFooterLink}>
                    {text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </HorizontalLayout>
    </HomeCard>
  );
}
